import { StreamEntityType } from 'types/enums';
import { PackType } from 'types/generated/graphql';

export function getStreamEntityType(type: PackType): StreamEntityType {
    return type === PackType.Repack
        ? StreamEntityType.Repacks
        : StreamEntityType.Packs;
}
